import { useEnvironmentType } from "../../contexts/useEnvType";
import { IntegrationType, useIntegrationsQuery } from "../../types";

export const useHasIntegration = (type: IntegrationType) => {
  const { isTactical } = useEnvironmentType();
  const { data } = useIntegrationsQuery({
    skip: isTactical,
  });

  return Boolean(data && data.integrations.includes(type));
};
